<template>
  <div class="dissertation">
    <div class="flex-grid-thirds">
      <div class="sml-col"/>
      <div class="col">
        <h1>An Evaluation of the Impact of Constraints on the Perceived Creativity of Narrative Generating Software</h1>

        <p>My <a href="../assets/Lewis Mckeown Dissertation.pdf" target="_blank">MSc dissertation</a> focused on computational creativity, specifically on narrative generation and the impact constraints have on the creativity of narrative generating software.</p>

        <p>My work was awarded the <a href="assets/SchoolOfComputingAward.pdf" target="_blank">School of Computing Prize for Outstanding Performance</a> for my graduating year.</p>

        <p>I also presented <a href="http://computationalcreativity.net/iccc2018/sites/default/files/iccc_proc18.pdf" target="_blank">a paper</a> based on my dissertation at the <a href="http://computationalcreativity.net/iccc2018/" target="_blank">the 9th International Conference on Computational Creativity in Salamanca, Spain in 2018</a>. The presentation took the form of a <a href="assets/LM ICCC18 Slides.pdf" target="_blank">short talk</a> and <a href="assets/Lewis Mckeown Anna Jordanous ICCC18 Poster.pdf" target="_blank">poster presentation</a>.</p>

        <a href="../assets/Lewis Mckeown Dissertation.pdf" target="_blank">Dissertation</a> / <a href="http://computationalcreativity.net/iccc2018/sites/default/files/iccc_proc18.pdf" target="_blank">ICCC 18 Paper</a>
      </div>
      <div class="sml-col"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Dissertation'
  }
</script>
<style scoped>
  .dissertation {
    text-align: center;

  }
  
  .flex-grid {
  display: flex;
  }
  .col {
    flex: 1;
  }

  @media screen and (max-width: 500px) {
    .flex-grid {
      display: block;
    }
  }

  .flex-grid-thirds {
    display: flex;
    justify-content: space-between;
  }

  .flex-grid-thirds .col {
    width: 32%;
  }

  .flex-grid-thirds .sml-col {
    width: 20%;
    text-align: left;
}
</style>
